import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Download, Mail, PlayCircle } from 'lucide-react';
export function ThankYouPage() {
  return <div className="min-h-screen bg-cream selection:bg-gold selection:text-white py-12 px-4" data-id="element-210">
      <div className="max-w-3xl mx-auto" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl shadow-elegant overflow-hidden border border-gold/10" data-id="element-212">
          {/* Header Area */}
          <div className="bg-brown text-cream p-8 md:p-12 text-center relative overflow-hidden" data-id="element-213">
            <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-214">
              <div className="absolute top-[-50%] right-[-10%] w-[300px] h-[300px] rounded-full border-2 border-gold" data-id="element-215"></div>
            </div>

            <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            delay: 0.3,
            type: 'spring'
          }} className="w-20 h-20 bg-gold rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-216">
              <CheckCircle className="w-10 h-10 text-white" data-id="element-217" />
            </motion.div>

            <h1 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-218">
              ¡Felicidades, estás dentro!
            </h1>
            <p className="text-lg text-cream/80 font-light" data-id="element-219">
              Tu pedido se ha procesado correctamente.
            </p>
          </div>

          {/* Content Area */}
          <div className="p-8 md:p-12" data-id="element-220">
            <div className="bg-ivory rounded-xl p-6 mb-10 border border-gold/20 flex items-start gap-4" data-id="element-221">
              <Mail className="w-6 h-6 text-terracotta flex-shrink-0 mt-1" data-id="element-222" />
              <div data-id="element-223">
                <h3 className="font-medium text-brown text-lg mb-2" data-id="element-224">
                  Paso 1: Revisa tu correo
                </h3>
                <p className="text-brown/70 leading-relaxed" data-id="element-225">
                  Hemos enviado un recibo y un enlace de respaldo a tu correo
                  electrónico. Si no lo ves en los próximos 5 minutos, revisa tu
                  carpeta de spam o promociones.
                </p>
              </div>
            </div>

            <div className="text-center mb-12" data-id="element-226">
              <h3 className="font-serif text-2xl text-brown mb-6" data-id="element-227">
                Paso 2: Accede a tu material ahora
              </h3>
              <button className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-gold hover:bg-gold-dark text-white rounded-full font-medium text-lg transition-all shadow-lg hover:shadow-xl w-full md:w-auto" data-id="element-228">
                <Download className="w-5 h-5" data-id="element-229" />
                DESCARGAR EL PROTOCOLO COMPLETO
              </button>
              <p className="text-sm text-brown/50 mt-4" data-id="element-230">
                Formato PDF - Compatible con todos los dispositivos
              </p>
            </div>

            <hr className="border-gold/10 mb-10" data-id="element-231" />

            {/* Welcome Video Section */}
            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-232">
              <div data-id="element-233">
                <h3 className="font-serif text-xl text-brown mb-4" data-id="element-234">
                  Un mensaje de bienvenida
                </h3>
                <p className="text-brown/70 mb-4 leading-relaxed" data-id="element-235">
                  "Has tomado la mejor decisión para tu salud en años. Estás a
                  punto de descubrir cómo tu cuerpo está diseñado para sanar
                  cuando le das las señales correctas."
                </p>
                <p className="text-sm font-medium text-terracotta" data-id="element-236">
                  Ve a tu correo ahora mismo para comenzar.
                </p>
              </div>

              <div className="relative rounded-xl overflow-hidden shadow-md group cursor-pointer" data-id="element-237">
                <img src="https://cdn.magicpatterns.com/uploads/ckd77p7orS9Mhk5sSds7sX/Gemini_Generated_Image_lo27kilo27kilo27.png" alt="Bienvenida" className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-238" />
                <div className="absolute inset-0 bg-brown/30 flex items-center justify-center group-hover:bg-brown/20 transition-colors" data-id="element-239">
                  <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center shadow-lg" data-id="element-240">
                    <PlayCircle className="w-8 h-8 text-gold" data-id="element-241" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}